import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { BigBlueButton } from 'lib/styles';

const RemoveButton = styled(BigBlueButton)`
	background-color: #9d0214;
	margin-bottom: 16px;

	&:hover,
	&:active {
		background-color: #D0021B;
	}
`;

const Container = styled.div`
  position: fixed;
  top: 0px;
	left: -350px;
	z-index: 12;

	display: flex;
	flex-direction: column;
	width: 350px;
	height: 100vh;

	background-color: ${props => props.open ? 'white' : 'rgba(255,255,255,0)'};
	border-right: 2px solid rgba(240,244,250, ${props => props.open ? '1' : '0'});
	cursor: ${props => props.open ? 'default' : 'pointer'};
	transform: translateX(${props => props.open ? '350px' : '0px'});
	transition: background-color 0.3s ease-out, transform 0.2s ease-out;

  &:hover {
    background-color: white;
    border-right: 2px solid rgba(240,244,250, 1);
  }
`;

const Handle = styled.button`
  position: absolute;
  top: 0px;
  right: -25px;
  width: 25px;
  height: 100vh;
  background-color: rgba(0,0,0,0);
  border: 0px;
  appearance: none;
  padding: 0;
  cursor: pointer;
  outline: none;

  &:after {
    content: '';
    position: absolute;
    top: calc(50% - 64px);
    right: 10px;
    width: 5px;
    height: 128px;
    border-radius: 3px;
    background: #D2D9E5;
  }
`;

const Dimmer = styled.button`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: black;
  opacity: ${props => props.open ? '0.3' : '0'};
  z-index: ${props => props.open ? '11' : '-1'};
	transition: opacity 0.3s ease-out, z-index 0s ease-out;
	border: 0px;
`;

const PagesContainer = styled.div`
	padding: 40px 20px 0 40px;
	overflow-y: auto;
	height: ${props => props.brochureEditable ? props.hasRemoveablePages ? 'calc(100vh - 200px)' : 'calc(100vh - 140px)' : '100vh'};
	width: 350px;
	transition: height 0.3s ease-out;
`;

const Pages = styled.div``;

const Page = styled.div`
	background-color: white;
  width: 275px;
  height: ${props => props.orientation === 'landscape' ? '194px' : '100px'};
  box-shadow: 0px 4px 8px -3px rgba(0,29,79,0.2);
	margin-bottom: 40px;
	position: relative;

	&:after {
		content: "";
		position: absolute;
		top: -6px;
		left: -6px;
		width: calc(100% + 8px);
		height: calc(100% + 8px);
		background-color: rgba(74,144,226, 0.02);
		border: 2px solid #4A90E2;
		border-radius: 4px;
		opacity: ${params => params.active === 1 ? 1 : 0};
		transition: opacity 0.2s ease-out;
		pointer-events: none;
	}
`;

const RemoveContainer = styled.div`
	position: absolute;
	top: 4px;
	left: 4px;
	z-index: 10;
	background-color: rgba(255,255,255, ${params => params.active ? 1 : 0.6});
	padding: 8px;
	border-radius: 4px;
	opacity: ${params => params.active ? 1 : 0};
	transition: opacity 0.2s ease-out;
	box-shadow: 0px 2px 4px rgba(0,0,0,0.2);

	svg,
	path {
		fill: #D0021B;
	}

	${Page}:hover & {
		opacity: ${params => params.active ? 1 : 0.6};

		&:hover {
			opacity: 1;
		}
	}
`;

const PageLink = styled(Link)`
	display: block;
	height: 195px;
	animation: none 0.2s infinite alternate;
	animation-play-state: ${props => props.delete ? 'running' : 'paused'};

	&:after {
		content: "";
    display: ${props => props.delete ? 'block' : 'none'};
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(255,0,0,0.3);
	}

	@keyframes shake {
		from {
			transform: translatex(-4px);
		}

		to {
			transform: translatex(4px);
		}
	}
`;

const DragHandle = styled.div`
	z-index: 10;
	position: absolute;
	top: 4px;
	right: 4px;
	width: 32px;
	height: 48px;
	background-color: white;
	border-radius: 4px;
	box-shadow: 0px 2px 4px rgba(0,0,0,0.2);
	opacity: ${props => props.isDragging ? '1' : '0'};
	transition: opacity 0.2s ease-out;
	display: ${props => props.canSort ? 'flex' : 'none'};
	flex-direction: column;
	justify-content: center;
	align-items: center;
	pointer-events: ${props => props.canSort ? 'normal' : 'none'};

	${Page}:hover & {
		opacity: 0.6;

		&:hover {
			opacity: 1;
		}
	}
`;

const PageNumber = styled.div`
	position: absolute;
	top: calc(50% - 15px);
	left: -40px;

	display: flex;
	width: 30px;
	height: 30px;
	align-items: center;
	justify-content: center;
	z-index: 10;

	color: #4A90E2;

	text-decoration: none;
	font-size: 14px;
`;

const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	padding: 40px;
	position: relative;

	&:before {
		content: "";
		position: absolute;
		bottom: 100%;
		left: 0px;
		width: 100%;
		height: 16px;
		z-index: 1;
		background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
	}

	button {
		width: 100%;
	}
`;

export {
	Container,
	RemoveButton,
	RemoveContainer,
	Handle,
	Dimmer,
	PagesContainer,
	Pages,
	Page,
	PageLink,
	DragHandle,
	PageNumber,
	ButtonContainer,
}
